import axios from 'axios';
import { api } from 'src/api';
import type { AlfaAuthResponse } from '@lt/api/dist/methods/client/types';
import type { CLIENT } from '@lt/api/dist/types/client';
import { sendCommonEvents } from 'src/helpers/sendCommonEvents';
import { pushAuthSuccessful } from '../analytics';
import { AuthMethodsForAnalytics } from '../types';

export const handleAlfaWebviewAuth = async (
  code: string,
  state: string,
  onSuccess: (client: CLIENT) => void,
  onError: (error: unknown) => void,
): Promise<void> => {
  if (!code || !state) {
    onError(new Error('Missing code or state parameters'));
    return;
  }

  try {
    const redirectTo = new URLSearchParams(window.location.search).get(
      'redirect_to',
    );
    const redirectUrl =
      window.location.origin + (redirectTo ? `?redirect_to=${redirectTo}` : '');

    const tokenPayload: AlfaAuthResponse = {
      code,
      state,
      redirect_url: redirectUrl,
    };

    const { client } = await api.postClientAuth({
      token: tokenPayload,
      provider: 'alfabank',
      use_cookies: true,
    });

    const authResponse = await axios.get(client.extra.auth_url);

    if (authResponse.data.success) {
      onSuccess(client);
      pushAuthSuccessful(AuthMethodsForAnalytics.Alfa);
      sendCommonEvents('oauth', 'alfabank');
      if (redirectTo) {
        window.location.href = redirectTo;
      }
    } else {
      throw new Error('Auth cookie authentification failed');
    }
  } catch (error) {
    onError(error);
  }
};
